<form [formGroup]="form">
  <portal-modal-header (onClose)="dismiss()" title="QuickJump"></portal-modal-header>

  <portal-modal-body (keydown.control.enter)="navigate()">
    <!-- Enterprise -->
    <div class="mb-3">
      <label class="form-label" for="enterpriseId">{{ 'Enterprise' | translate }}</label>

      <ng-select
        id="enterpriseId"
        [clearable]="false"
        [items]="enterprises"
        [portalAutofocus]="true"
        bindLabel="name"
        bindValue="name"
        formControlName="enterpriseId"
        portalInputValidityState
      ></ng-select>

      <portal-form-validation-errors controlName="enterpriseId"></portal-form-validation-errors>
    </div>

    <!-- Users -->
    <div class="mb-3">
      <label class="form-label" for="userId">{{ 'User' | translate }}</label>

      <ng-select
        id="userId"
        #userSelect
        [clearable]="false"
        [items]="users"
        bindLabel="loginName"
        bindValue="loginName"
        formControlName="userId"
        portalInputValidityState
      ></ng-select>

      <portal-form-validation-errors controlName="userId"></portal-form-validation-errors>
    </div>

    <!-- Routes -->
    <div>
      <label class="form-label" for="route">{{ 'Route' | translate }}</label>

      <ng-select
        id="route"
        [clearable]="false"
        [items]="routes"
        formControlName="route"
        portalInputValidityState
      >
        <ng-template let-item="item" ng-label-tmp ng-option-tmp>
          {{ 'route.' + item | translate }}
        </ng-template>
      </ng-select>

      <portal-form-validation-errors controlName="route"></portal-form-validation-errors>
    </div>
  </portal-modal-body>

  <div class="modal-footer">
    <button class="btn btn-default" (click)="dismiss()">{{ 'button.cancel' | translate }}</button>
    <button class="btn btn-primary" (click)="navigate()">Navigate</button>
  </div>
</form>
